import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://46f1484259c883ef3f5a12f03ce40887@o4507333642158080.ingest.de.sentry.io/4507333708873808',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.feedbackIntegration({
      showBranding: false,
      showName: false,
      autoInject: false,
    }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    // Sentry.captureConsoleIntegration()
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  allowUrls: [
    /^https:\/\/dev\.rock-paper-scissors\.game/,
    /^https:\/\/app\.rock-paper-scissors\.game/,
  ],
});
